import { makeStyles, tokens } from "@fluentui/react-components";
/**
 * Styles for the Confirmation dialog
 */ export const useConfirmationDialogStyles = makeStyles({
    dialogSurface: {
        minHeight: "auto"
    },
    message: {
        color: tokens.colorNeutralForeground1,
        fontSize: tokens.fontSizeBase300
    },
    secondaryMessage: {
        color: tokens.colorNeutralForeground1,
        fontSize: tokens.fontSizeBase200,
        marginBottom: tokens.spacingVerticalL
    },
    dialogActions: {
        gap: tokens.spacingHorizontalM,
        justifyContent: "flex-end"
    },
    actionButtons: {
        borderRadius: tokens.borderRadiusXLarge,
        minWidth: "auto"
    }
});
